import { Component, Inject, OnInit } from '@angular/core';
import { ContractService } from '../../shared/contract.service';
import { Contract } from '../../shared/contract.model';
import { UserService } from 'src/app/shared/user.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MyErrorStateMatcher } from '../clause/add-clause/add-clause.component';
import { Router } from '@angular/router';
import { Dialog } from '@angular/cdk/dialog';
import { RejectDialogComponent } from '../reject-dialog/reject-dialog.component';
import * as moment from 'moment';

@Component({
  selector: 'app-task-dialog',
  templateUrl: './task-dialog.component.html',
  styleUrl: './task-dialog.component.scss'
})
export class TaskDialogComponent implements OnInit {
  contractForApproval: Contract;
  summaryAttributes = [];
  formLoading: boolean = false;
  isLoading: boolean = false;

  constructor(private contractService: ContractService, private userService: UserService, @Inject(MAT_DIALOG_DATA) public data: any, private toast: ToastrService, private router: Router, private dialogRef: MatDialogRef<TaskDialogComponent>, private dialog: MatDialog) {

  }


  formatDate(value: string): string {
    return moment(value).isValid() ? moment(value).format("Do MMMM YYYY") : value;
  }

  async ngOnInit() {
    this.formLoading = true;
    await this.contractService
      .getContract(parseInt(this.data.contractId))
      .then((contract: Contract) => {
        this.contractForApproval = contract;
        this.contractService
          .getContractSummaryAttributeForAContract(parseInt(this.data.contractId))
          .then((list: Array<any>) => {
            this.summaryAttributes = list;
            this.formLoading = false;
          });
      });

  }
  close() {
    this.dialogRef.close();
  }

  async approveOrReview() {
    this.isLoading = true;
    try {
      if (this.data.activeTileIndication == 3) {
        await this.contractService.approveContract(this.data.contractId).then((res) => {
          this.toast.success('Contract Approved Successfully!', '');
        });
      } else {
        await this.contractService.reviewContract(this.data.contractId).then((res)=>{
          this.toast.success('Contract Reviewed Successfully!', '');
        });
      }
      this.isLoading = false;
      this.dialogRef.close();
      this.data.initialize();
    } catch (error) {
      console.error(this.data.activeTileIndication == 3 ? 'Approve failed' : 'Complete review failed', error);
      this.toast.error(
        this.contractService.describeError(error) ||
        'Something went wrong, Please try again later!',
        this.data.activeTileIndication == 3 ? 'Approval failed' : 'Review failed'
      );
      this.isLoading = false;
    }
  }

  async openRejectDialog() {
    const dialogRef =
      this.dialog.open(RejectDialogComponent, {
        enterAnimationDuration: '400ms',
        exitAnimationDuration: '500ms',
        width: '40%',
        disableClose: true,
        data: {
          contractName: this.data.contractName,
          contractId: this.data.contractId,
          tileId: this.data.activeTileIndication,
          initialize: () => this.initialize(),
        }
      });
  }

  initialize() {
    this.data.initialize();
  }

  viewContract(id) {
    this.dialogRef.close();
    this.router.navigate(['/app/contract', id, 'step', '4', '1']);
  }
}
